/**
 * @file go-design-ui
 * @description go-design-ui 组件库的引入
 * @wiki http://globalone.didichuxing.com/mobile-vue-docs#/zh-CN/docs/Introduction?type=Phone
 */
import Vue from 'vue'
import { Style as goStyle, Toast, Button } from '@didi/go-design-mobile-vue'
import store from './store'

Vue.use(goStyle)
Vue.use(Toast)
Vue.use(Button)

const { country } = store.state
// 巴西使用99主题
if (country === 'BR') {
  // 使用主题编辑器生成样式，参考：wiki => 更新主题
  import('./common/css/go-design-theme.css')
}
